const DEEPLINK_PATH = 'deeplink';

/**
 * Checks if the current location is a deeplink or not.
 * @param location pass the location as optional parameter.
 */
export default function isDeepLink(location?: Location) {
    const givenLocation = location ? location : window.location;
    const path = givenLocation ? givenLocation.pathname : '';
    const segments = path.split('/');
    return segments.indexOf(DEEPLINK_PATH) >= 0;
}
